import bookImg from '../../../../assets/images/gefen-programs/virtual-high-school/book.png';
import matImg from '../../../../assets/images/gefen-programs/virtual-high-school/mat.png';
import studentImg from '../../../../assets/images/gefen-programs/virtual-high-school/student.png';
import mathBookImg from '../../../../assets/images/gefen-programs/virtual-high-school/Mathematics-book.png';
import computerImg from '../../../../assets/images/gefen-programs/virtual-high-school/computer.png';
import staircaseImg from '../../../../assets/images/gefen-programs/virtual-high-school/row-2.png';
import logoImg from '../../../../assets/images/gefen-programs/virtual-high-school/logo.png';
import jumpingImg from '../../../../assets/images/gefen-programs/virtual-high-school/Jumping.png';

export const jumping = jumpingImg;

export const staircase = staircaseImg;
export const book = bookImg;
export const mat = matImg;
export const student = studentImg;
export const mathBook = mathBookImg;
export const computer = computerImg;
export const logo = logoImg;

// Each line [x1, y1, x2, y2] becomes 3 jittered frames for StopMotionSvg
const jitter = [[0, 0], [3, -3], [-3, 3]];
const toShapes = (lines) => lines.map(([x1, y1, x2, y2], i) =>
  [0, 1, 2].map((f) => {
    const [dx, dy] = jitter[(f + i) % 3];
    return `M${x1 + dx} ${y1 + dy}L${x2 - dx} ${y2 + dy}`;
  }));

export const stepLines1 = { width: 110, height: 90, shapes: toShapes([[33.4, 11, 18.6, 49], [70, 6, 72, 46]]) };

export const stepLines2 = { width: 150, height: 90, shapes: toShapes([[8, 20, 48, 40], [62, 8, 78, 48], [118, 20, 106, 38], [140, 50, 140, 70]]) };

export const stepLines3 = { width: 110, height: 90, shapes: toShapes([[50, 8, 36, 48], [80, 10, 98, 46]]) };

export const triangle = <svg xmlns="http://www.w3.org/2000/svg" width="90" height="100" viewBox="0 0 90 100" fill="none">
  <g clipPath="url(#clip0_6555_23687)">
    <path d="M0 0L90 50L0 100V0Z" fill="#49DF23" />
  </g>
  <defs>
    <clipPath id="clip0_6555_23687">
      <rect width="90" height="100" fill="white" />
    </clipPath>
  </defs>
</svg>;

export const sparkle = <svg xmlns="http://www.w3.org/2000/svg" width="161" height="163" viewBox="0 0 161 163" fill="none">
  <g clipPath="url(#clip0_6555_23674)">
    <path d="M117.587 52.7698L91.2119 77.5968Z" fill="black" />
    <path d="M117.587 52.7698L91.2119 77.5968" strokeWidth="9" strokeLinecap="round" stroke="#F6BA55" />
    <path d="M64.3685 35.2241L64.8065 72.4237Z" fill="black" />
    <path d="M64.3685 35.2241L64.8065 72.4237" strokeWidth="9" strokeLinecap="round" stroke="#F6BA55" />
    <path d="M126.436 101.161L90.4379 103.197Z" fill="black" />
    <path d="M126.436 101.161L90.4379 103.197" strokeWidth="9" strokeLinecap="round" stroke="#F6BA55" />
  </g>
  <defs>
    <clipPath id="clip0_6555_23674">
      <rect width="120" height="110" fill="white" transform="translate(87.9325) rotate(53.0715)" />
    </clipPath>
  </defs>
</svg>;

